/**
 * @file getFrontend.js
 *
 * Gets information about the current or specified frontend. This file is a .js file because its consumed
 * from the next.config.js which does not support typescript.
 */
const { getFrontendConfig } = require('./getConfig');
let appConfig = require('./../../../config/app');
const FRONTENDS = appConfig.public.FRONTENDS;

/**
 * Get the current frontend machine name.
 *
 * @returns {string}
 *   The current frontend machine name.
 */
export const getFrontend = (frontendConfig) => {
  const frontendKey = frontendConfig
    ? frontendConfig.frontend
    : process.env.NEXT_PUBLIC_FRONTEND;
  // Catch what frontend we are building.
  const frontend =
    frontendKey && frontendKey !== 'default'
      ? FRONTENDS[frontendKey]
      : FRONTENDS.default;
  return frontend;
};

/**
 * Prepares mocking of config for unit tests.
 */
export const setupTestingFrontends = (testFrontends) => {
  Object.assign(FRONTENDS, testFrontends);
  return getFrontend();
};

/**
 * Loads frontend theme settings from the frontend config.
 *
 * @param {*} frontendConfig
 *  The frontend config. Should always be passed when reading from components or pages.
 * @returns
 *  The frontend theme.
 */
export const getFrontendTheme = (frontendConfig) => {
  const frontend = getFrontend(frontendConfig);
  return getFrontendConfig('app', frontend).public.THEME ?? {};
};

/**
 * Loads frontend assets from the frontend config.
 *
 * @param {*} frontendConfig
 *  The frontend config. Should always be passed when reading from components or pages.
 * @returns
 *  The frontend assets.
 */
export const getFrontendAssets = (frontendConfig) => {
  const frontend = getFrontend(frontendConfig);
  return getFrontendConfig('app', frontend).public.ASSETS ?? {};
};

/**
 * Loads the frontend assets for the specified frontend.
 *
 * @param frontend
 *  The specific frontend key to load assets from.
 * @returns
 *  The frontend assets.
 */
export const getSpecificFrontendAssets = (frontend) => {
  return getFrontendConfig('app', frontend).public.ASSETS ?? {};
};

/**
 * Gets the site name for the specified frontend.
 *
 * @param frontend
 *  The specific frontend key to get the site name for.
 * @returns
 *  The site name.
 */
export const getFrontendSiteName = (frontend) => {
  return getFrontendConfig('app', frontend).public.SITENAME ?? '';
};
